/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { INSPECTOR_NODE_TYPE, TInspectorNode } from "../InspectorNodeTypes";
import { ISchemaCommentsModel, isSchemaCommentsModel } from "@adapptio/lib-blueprint";
import { IInspectorControl_Comments, INSPECTOR_CONTROL_TYPE } from "../controls";
import { createDefaultNode } from "../createDefaultNode";
import { mapperDescriptor } from "../../modules/Core/ReferenceGuide/mappers/mapperDescriptor";
import { mapperExamples } from "../../modules/Core/ReferenceGuide/mappers/mapperExamples";
import { getParentComponentName } from "../utils";

export function commentsMapper(model: ISchemaCommentsModel): TInspectorNode {
	if (!isSchemaCommentsModel(model)) {
		return;
	}

	const control: IInspectorControl_Comments = {
		key: String(model.nodeId),
		type: INSPECTOR_CONTROL_TYPE.COMMENTS,
		model
	};

	return {
		type: INSPECTOR_NODE_TYPE.DEFAULT,
		key: `${model.nodeId}`,
		label: model.schema.opts.label,
		required: model.schema.opts.constraints?.required || false,
		default: model.schema.opts.default || null,
		referenceData: getParentComponentName(model),
		descriptor: mapperDescriptor(model.schema),
		examples: mapperExamples(model.schema),
		options: model.schema.opts["options"],
		tooltip: model.schema.opts.description,
		deps: [ model ],
		controls: [],
		children: [ () => createDefaultNode({ controls: [ control ] }) ]
	};
}
